import React from 'react'
import useSmartviewManager from './use-smartview-manager'

export default function useOnSmartviewMount (callback, deps = []) {
  const manager = useSmartviewManager()

  React.useEffect(() => {
    if (typeof callback !== 'function') {
      return
    }

    const disposer = manager.onMount(() => {
      callback()
    })

    return () => {
      disposer()
    }
  }, deps)
}
